import axiosApiInstance from "../../interceptors/axiosApiInstance";
import { BASE_URL } from "../config";

const ProfileService = {
  addActioneerProfile: async function (data) {
    try {
      const response = await axiosApiInstance.post(BASE_URL + `/profile/actioneer`, data);
      return response.data;
    } catch (error) {
      return error.response ? error.response.data : undefined;
    }
  },
  getAllActioneersProfile: async function () {
    try {
      const response = await axiosApiInstance.get(BASE_URL + `/profile/actioneers`);
      return response.data;
    } catch (error) {
      return error.response ? error.response.data : undefined;
    }
  },
  deleteActioneerProfile: async function (ids) {
    try {
      const response = await axiosApiInstance.delete(BASE_URL + `/profile/actioneers`,{ data:{ ids }});
      return response.data;
    } catch (error) {
      return error.response ? error.response.data : undefined;
    }
  },
  getByActioneerProfile: async function (id) {
    try {
      const response = await axiosApiInstance.get(BASE_URL + `/profile/actioneer/${id}`);
      return response.data;
    } catch (error) {
      return error.response ? error.response.data : undefined;
    }
  },
  editActioneerProfile: async function (id, data) {
    try {
      const response = await axiosApiInstance.put(BASE_URL + `/profile/actioneer/${id}`, data);
      return response.data;
    } catch (error) {
      return error.response ? error.response.data : undefined;
    }
  },
  getAllAlertRules: async function () {
    try {
      const response = await axiosApiInstance.get(BASE_URL + `/profile/alert/rules`);
      return response.data;
    } catch (error) {
      return error.response ? error.response.data : undefined;
    }
  },
  addAlertProfile: async function (data) {
    try {
      const response = await axiosApiInstance.post(BASE_URL + `/profile/alert`, data);
      return response.data;
    } catch (error) {
      return error.response ? error.response.data : undefined;
    }
  },
  getAlertByAlertRule: async function (id) {
    try {
      const response = await axiosApiInstance.get(BASE_URL + `/profile/alert/${id}/rules`);
      return response.data;
    } catch (error) {
      return error.response ? error.response.data : undefined;
    }
  },
  getAllListAlertRule: async function () {
    try {
      const response = await axiosApiInstance.get(BASE_URL + `/profile/alerts`);
      return response.data;
    } catch (error) {
      return error.response ? error.response.data : undefined;
    }
  },
  deleteByAlertRule: async function (ids) {
    try {
      const response = await axiosApiInstance.delete(BASE_URL + `/profile/alerts`,{ data:{ ids }});
      return response.data;
    } catch (error) {
      return error.response ? error.response.data : undefined;
    }
  },
  getActioneersByAlertProfile: async function (id) {
    try {
      const response = await axiosApiInstance.get(BASE_URL + `/profile/alert/${id}/actioneers`);
      return response.data;
    } catch (error) {
      return error.response ? error.response.data : undefined;
    }
  },
  getAutomsByAlertProfile: async function (id) {
    try {
      const response = await axiosApiInstance.get(BASE_URL + `/profile/alert/${id}/automs`);
      return response.data;
    } catch (error) {
      return error.response ? error.response.data : undefined;
    }
  },
  updateAlertProfile: async function (id, data) {
    try {
      const response = await axiosApiInstance.put(BASE_URL + `/profile/alert/${id}`, data);
      return response.data;
    } catch (error) {
      return error.response ? error.response.data : undefined;
    }
  },
  getAlertProfile: async function (id) {
    try {
      const response = await axiosApiInstance.get(BASE_URL + `/profile/alert/${id}`);
      return response.data;
    } catch (error) {
      return error.response ? error.response.data : undefined;
    }
  },
  getActioneerResults: async function () {
    try {
      const response = await axiosApiInstance.get(BASE_URL + `/profile/actioneer/results`);
      return response.data;
    } catch (error) {
      return error.response ? error.response.data : undefined;
    }
  },
  deleteActioneerResult: async function (ids) {
    try {
      const response = await axiosApiInstance.delete(BASE_URL + `/profile/actioneer/results`, { data: { ids } });
      return response.data;
    } catch (error) {
      return error.response ? error.response.data : undefined;
    }
  },
  getByActioneerResult: async function (id) {
    try {
      const response = await axiosApiInstance.get(BASE_URL + `/profile/actioneer/result/${id}`);
      return response.data;
    } catch (error) {
      return error.response ? error.response.data : undefined;
    }
  },
  testActioneerProfile: async function (data) {
    try {
      const response = await axiosApiInstance.post(BASE_URL + `/profile/actioneer/test`, data);
      return response.data;
    } catch (error) {
      return error.response ? error.response.data : undefined;
    }
  }
};
export default ProfileService;